import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start justify-start my-6 md:max-w-[666px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-6" }, [
  /*#__PURE__*/_createTextVNode("NIP pracodawcy "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "error-message" }

import { Field, useField } from 'vee-validate';


export default {
  __name: 'NIPField',
  setup(__props) {

const { value, errors, errorMessage } = useField('nip');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(Field), {
      name: "nip",
      class: _normalizeClass(["rounded-xl w-full", {
                'border-[1px] border-error border-solid': _unref(errors).length,
                'border-none': !_unref(errors).length,
            }]),
      type: "text",
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null))
    }, null, 8, ["class", "modelValue"]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1)
  ]))
}
}

}